import axios from "axios";
import { BASE_URL_STRING } from "./axios";

export const BASE_URL = BASE_URL_STRING;
export const EducationStageEndPoints = {
  all: "education-stages/list",
  create: "education-stages/add"
};
export const CenterEndPoints = {
  all: "centers/list",
  create: "centers/add",
  update: (id) => `centers/update/${id}`,
  delete: (id) => `centers/delete/${id}`,
}

export const createGeneralAPIEndpoint = (endpoint) => {
  let url = BASE_URL + "v1/general/" + endpoint;
  const token = sessionStorage.getItem("token");
  return {
    fetch: (options) =>
      axios.get(url, {
        ...options,
        headers: { Authorization: `Bearer ${token}` },
      }),

    post: (newRecord) => axios.post(url, newRecord),
    postWithToken: (newRecord) =>
      axios.post(url, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    postById: (id, newRecord) =>
      axios.post(url + id, newRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    put: (updatedRecord) =>
      axios.put(url, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    putById: (id, updatedRecord) =>
      axios.put(url + id, updatedRecord, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    delete: () =>
      axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
  };
};